//Cloud Native Ingestion max, min & default values
export const DEFAULT_INGESTION = 400;
export const MIN_INGESTION = 50;
export const MAX_INGESTION = 10000;

// Pricing Tiers
export const TIER1 = 1;
export const TIER201 = 201;
export const TIER301 = 301;
export const TIER401 = 401;
export const TIER501 = 501;
export const TIER1001 = 1001;
export const TIER2001 = 2001;
export const TIER5001 = 5001;
export const INGESTION_TIERS = [
  TIER1,
  TIER201,
  TIER301,
  TIER401,
  TIER501,
  TIER1001,
  TIER2001,
  TIER5001,
];

export enum Package {
  essentials = 'Essentials',
  standard = 'Standard', // to be used in future
  premium = 'Premium', // to be used in future
}
